import { cn } from '@/utils/cn'
import type { ComponentProps } from 'react'
import { BorrowMarketTxNotSupportedPanel } from './borrowMarketTxNotSupportedPanel'

export const BorrowMarketSidePanel = ({ className, ...props }: ComponentProps<'aside'>) => (
  <aside className={cn('h-fit flex-col gap-4', className)} data-role="side-panel" data-location="side" {...props}>
    <BorrowMarketTxNotSupportedPanel />
  </aside>
)
